// in src/authProvider.js
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS} from 'react-admin';

const setAccessControlHeaders = headers => headers.set('Access-Control-Request-Headers',
    [
        'Content-Type', 'Content-Range',
        'If-Modified-Since', 'Cache-Control',
        'Access-Control-Allow-Origin'
    ].join()
);
export const authProvider =  (type, params) => {
    console.info('Auth type:', type);
    if (type === AUTH_LOGIN) {
        const { username, password } = params;
        const request = new Request('https://staging.filmon.com/auth-api/authenticate', {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        setAccessControlHeaders(request.headers);
        try {
            return fetch(request)
                .then(response => {
                    if (response.status < 200 || response.status >= 300) {
                        throw new Error(response.statusText);
                    }
                    return response.json();
                })
                .then(({token}) => {
                    localStorage.setItem('token', token);
                });
        } catch (err ) {
            console.error("PIZDA");
        }
    }
    if (type === AUTH_ERROR) {
        console.error("Athentication error", params);
        const status  = ~~params.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            console.log("After remove: ", localStorage.getItem('token'));
            return Promise.reject();
        }
        return Promise.resolve();
    }
    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('token');
        return Promise.resolve();
    }
    if (type === AUTH_CHECK) {
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
    }

    if ( type === AUTH_GET_PERMISSIONS ) {
        return Promise.resolve('admin');
    }
    console.error('Unknown auth method');
    return Promise.reject('Unknown auth method');
};

export const authInterceptor = (next) => (url, options = {}) => {
    next = next || fetch;
    if (!options.headers) {
        options.headers = new Headers({
            Accept: 'application/json'
        });
    }
    const token = localStorage.getItem('token');
    if (token) options.headers.set('Authorization', `Bearer ${token}`);
    setAccessControlHeaders(options.headers);
    console.debug("Set auth headers for ", url, options);
    return next(url, options).then(response => {
        const status = ~~response.status;

        if ( status === 401 || status === 403 ) {
            console.error("Unauthenticated:", response.statusText);
            if ( localStorage.getItem('token') ) {
                window.location.reload();
                localStorage.removeItem('token');
            }

            return Promise.reject(response);
        }
        return response;
    }).catch(err => console.log("ERRR", err));
};
